import axios from 'axios'
import { setHeader } from '../../helpers/setHeader'
import router from '../../routes'

const state = {
  auth: {
    isAuthenticated: false
  }
}

const getters = {
  getAuth: state => state.auth,
  getLink: state => state.mobileAuthorizeLink,
  isAdmin: state => state.auth && state.auth.role === 'super-admin',
  isUser: state => state.auth && state.auth.role === 'client-user',
  getTokenType: state => state.auth && state.auth.token_type,
  getToken: state => state.auth && state.auth.access_token,
  isAuthenticated: state => state.auth.isAuthenticated
}

const actions = {
  async login ({ commit }, { data, success, error }) {
    await axios({
      method: 'post',
      url: `/auth`,
      data: {
        ...data,
        grant_type: 'password',
        client_id: process.env.VUE_APP_API_CLIENT_ID,
        client_secret: process.env.VUE_APP_API_SECRET
      }
    })
      .then(resp => {
        commit('setAuth', resp.data)
        success('You logged in successfully', { className: 'success-toast' })
        setHeader(`${resp.data.token_type} ${resp.data.access_token}`)
        if (resp.data.need_mobile_pay_auth) {
          let fetch = async function () {
            await axios({
              method: 'get',
              url: `/auth-mobilepay`
            })
              .then(resp => {
                commit('setLink', resp.data.url)
                router.push('/auth/authorize')
              })
              .catch(err => console.log(err))
          }
          fetch()
        }
        // if (resp.data.need_issuer_) {
        //   let fetch = async function() {
        //     await axios({
        //       method: "get",
        //       url: `/auth-mobilepay`
        //     })
        //       .then(resp => {
        //         window.location = resp.data.url
        //       })
        //       .catch(err => console.log(err))
        //   };
        //   fetch();
        // }
        resp.data.role === 'client-user' && router.push('/dashboard/customers')
        resp.data.role === 'super-admin' && router.push('/dashboard/clients')
      })
      .catch(e => {
        error('Invalid account or password', { className: 'error-toast' })
      })
  },
  logout ({ commit }) {
    commit('logout')
    router.push('/auth/login')
  },
  async forgotPass ({ commit }, email) {
    await axios({
      method: 'post',
      url: `/forgot-password`,
      data: email
    })
      .then(resp => {
        router.push('/auth/login')
      })
      .catch(err => {
        console.log(err)
      })
  },
  async newPass ({ commit }, { token, password }) {
    await axios({
      method: 'post',
      url: `/new-password`,
      data: {
        token,
        password
      }
    })
      .then(resp => {
        router.push('/auth/login')
      })
      .catch(err => {
        console.log(err)
      })
  },
  async setPass ({ commit }, { token, password }) {
    await axios({
      method: 'post',
      url: `/set-password`,
      data: {
        token,
        password
      }
    })
      .then(resp => {
        router.push('/auth/login')
      })
      .catch(err => {
        console.log(err)
      })
  }
}

const mutations = {
  setAuth: (state, auth) => {
    state.auth = { ...auth, isAuthenticated: true }
  },
  setLink: (state, link) => {
    state.mobileAuthorizeLink = link
  },
  logout: state => {
    state.auth = {
      isAuthenticated: false
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
